import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { RequestDetails, SupportingDocumentClaimsGridColumn } from './supportiing-document-claims-model';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { SupportingDocumentService } from '../../services/supportingDocument.service';

@Component({
  selector: 'app-supporting-document-claims',
  templateUrl: './supporting-document-claims.component.html',
  styleUrls: ['./supporting-document-claims.component.scss']
})
export class SupportingDocumentClaimsComponent {

  public totalCount :any;
  public numberOfItemsPerPage:number;
  public requestDetails= new RequestDetails();
  public sortColumn:string = '';
  public sortOrder:string = 'A';
  public pageNumber:number = 1;
  public pageSize: number = 10;
  public adjudicationId: string;
  public engagementId: string;
  public supportingDocumentClaimGridList: any;
  public defaultSortEnabled: boolean = false;

  public dataSource:any = [];
  public displayColumns: string[] = [
    'dateSent',
    'action',
    'status',
    'statusUpdatedDate'
  ];
  creditorList: any[] = [];
  constructor(public dialogRef: MatDialogRef<SupportingDocumentClaimsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dataService: SupportingDocumentService,
    private router: Router, private spinnerService: NgxSpinnerService, private dialog: MatDialog) {}

    ngOnInit(): void {
      this.getSupportingDocumentGridDetails();
     

    }

    //Get grid details of supporting documents
    getSupportingDocumentGridDetails(){
       this.spinnerService.show();
      this.requestDetails.sortColumn = this.sortColumn;
      this.requestDetails.sortOrder = this.sortOrder;
      this.requestDetails.pageNumber = this.pageNumber;
      this.requestDetails.pageSize = this.pageSize;
      this.requestDetails.adjudicationId = this.data.adjudicationId;
      this.requestDetails.engagementId = this.data.engagementId;
      this.dataService.getSupportingDocumentGridlist(this.requestDetails).subscribe((response: any)=> {
        this.dataSource = response.supportingDocumentGridList;
        this.totalCount = response.totalCount;
        this.dataSource.forEach((x) => {
          x.dateSent = x.dateSent ? "" + moment(x.dateSent).format('DD-MMM-YYYY, h:mm A') : null;
          x.statusUpdatedDate = x.statusUpdatedDate ? "" + moment(x.statusUpdatedDate).format('DD-MMM-YYYY, h:mm A') : null;
        });
        this.spinnerService.hide();
      });
    }

    //Method to sort grid column
    onClickToSortHeader(data: { active: string; direction: string }) { 


      let asc: string = '-';
      let des: string = '+';
  
      if (data.direction == 'desc') { 
        this.sortColumn = des.concat(this.getSortColumnName(data.active));
      } else if (data.direction == 'asc') {
        this.sortColumn = asc.concat(this.getSortColumnName(data.active));
      }
  
     if(data.direction!=""){
      this.getSupportingDocumentGridDetails();
     }
    }

    private getSortColumnName(value: string): string {
      switch (value) {
        case 'dateSent':
          return SupportingDocumentClaimsGridColumn.dateSent;
        case 'action':
          return SupportingDocumentClaimsGridColumn.action;
        case 'status':
          return SupportingDocumentClaimsGridColumn.status;
        case 'statusUpdatedDate':
          return SupportingDocumentClaimsGridColumn.statusUpdatedDate;
      }
    }
    public onClickToChangePageSize(val,ds:any) { 
      this.pageSize = val.pageSize;
      this.numberOfItemsPerPage = val.pageSize;
      this.pageNumber = val.selectedPage;
      this.getSupportingDocumentGridDetails();
    }
  onClickToRedirectToView(){}

  closeDialog(){
    this.dialogRef.close({ data: this.data.Supporting_Documents_Cancel });
  }

  onClicktoOpenDetailDialog(element:any){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(["supporting-documents-claim-detail", {adjudicationId:element?.adjudicationId, supportingDocumentId : element?.supportingDocumentId}])
    );
    window.open(url, '_blank');
  }


}
